// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"3c7f5c92","770":"8bab16e0","832":"bfd99f69"}[chunkId] + ".chunk.js";
};